import config from "@/config"
import http from "@/utils/request"

export default {
	index: {
		url: `${config.API_URL}/bwmall/admin.BwmallShopProduct`,
		name: "商品列表",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
	setShow: {
		url: `${config.API_URL}/bwmall/admin.BwmallShopProduct/setShow`,
		name: "变更商品状态",
		post: async function(params){
			return await http.post(this.url, params);
		}
	},
	del: {
		url: `${config.API_URL}/bwmall/admin.BwmallShopProduct/del`,
		name: "删除商品状态",
		post: async function(params){
			return await http.post(this.url, params);
		}
	},
	getCategory: {
		url: `${config.API_URL}/bwmall/admin.BwmallShopProduct/getCategory`,
		name: "商品分类",
		get: async function(params){
			return await http.get(this.url, params);
		}
	},
	edit:{
		url: `${config.API_URL}/bwmall/admin.product/editNew`,
		name: "编辑商品",
		get: async function(params){
			return await http.get(this.url, params);
		},
		post: async function(params){
			return await http.post(this.url, params);
		},
	},
	add:{
		url: `${config.API_URL}/bwmall/admin.product/addNew`,
		name: "编辑商品",
		get: async function(params){
			return await http.get(this.url, params);
		},
		post: async function(params){
			return await http.post(this.url, params);
		},
	},
	generateRule:{
		url: `${config.API_URL}/bwmall/admin.product/generateRule`,
		name: "生成商品规格",
		post: async function(params){
			return await http.post(this.url, params);
		}
	},
	saveTemplate:{
		url: `${config.API_URL}/bwmall/admin.BwmallShopProduct/savetemplate`,
		name: "保存规格模板",
		post: async function(params){
			return await http.post(this.url, params);
		}
	},
	template:{
		index:{
			url: `${config.API_URL}/bwmall/admin/template/index`,
			name: "运费模板列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		del:{
			url: `${config.API_URL}/bwmall/admin/template/del`,
			name: "删除运费模板",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		getMapData:{
			url: `${config.API_URL}/manage/common/getMapData`,
			name: "获取地址信息",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		edit:{
			url: `${config.API_URL}/bwmall/admin/template/edit`,
			name: "编辑运费模板",
			get: async function(params){
				return await http.get(this.url, params);
			},
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		add:{
			url: `${config.API_URL}/bwmall/admin/template/add`,
			name: "添加运费模板",
			post: async function(params){
				return await http.post(this.url, params);
			}
		}
	},
	common:{
		index:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductReply`,
			name: "商品评论列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		add:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductReply/add`,
			name: "添加商品评论",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		edit:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductReply/edit`,
			name: "编辑评论回复内容",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		del:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductReply/del`,
			name: "删除评论",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
	},
	category:{
		index:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductCategory`,
			name: "商品分类列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		add:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductCategory/add`,
			name: "添加商品分类列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		edit:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductCategory/edit`,
			name: "编辑商品分类列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		setShow:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductCategory/setShow`,
			name: "变更商品分类列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		del:{
			url: `${config.API_URL}/bwmall/admin.BwmallShopProductCategory/del`,
			name: "删除商品分类列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
	},
	superHot:{
		index:{
			url: `${config.API_URL}/manage/member/groupData/getConfigList`,
			name: "爆款商品列表",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		add:{
			url: `${config.API_URL}/manage/member/groupData/add`,
			name: "添加爆款商品列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		edit:{
			url: `${config.API_URL}/manage/member/groupData/edit`,
			name: "编辑爆款商品列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		del:{
			url: `${config.API_URL}/manage/member/groupData/softdleting`,
			name: "删除爆款商品列表",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		setConfigShow:{
			url: `${config.API_URL}/manage/member/groupData/setConfigShow`,
			name: "变更爆款商品列表状态",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
	},
	hotKeys:{
		index:{
			url: `${config.API_URL}/manage/member/groupData/getConfigList`,
			name: "热搜词",
			get: async function(params){
				return await http.get(this.url, params);
			}
		},
		add:{
			url: `${config.API_URL}/manage/member/groupData/add`,
			name: "添加热搜词",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		edit:{
			url: `${config.API_URL}/manage/member/groupData/edit`,
			name: "编辑热搜词",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		del:{
			url: `${config.API_URL}/manage/member/groupData/softdleting`,
			name: "删除热搜词",
			post: async function(params){
				return await http.post(this.url, params);
			}
		},
		setConfigShow:{
			url: `${config.API_URL}/manage/member/groupData/setConfigShow`,
			name: "变更热搜词",
			post: async function(params){
				return await http.post(this.url, params);
			}
		}
	}
}
